import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { nomService } from '../../services/api/nom.service';
import { alertService } from '../../services/helpers/alert.service';
import { reportService } from '../../services/api/report.service';
import { utils } from "../../services/helpers/utils";

export const PatientConsultations = ({ cnp, activeComponent, searchCode }) => {
    const [consultatii, setConsultatii] = useState([]);
    const navigate = useNavigate();
    const partener = sessionStorage.getItem('idPartener');

    useEffect(() => {
        if (cnp) {
            nomService.getConsultation({ code: cnp, partener: partener })
                .then(response => {
                    if (response) {
                        setConsultatii(response);
                    }
                    else {
                        setConsultatii(null);
                    }
                });
        }
    }, [cnp]);

    const handleView = (page, param, value) => {

        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }

    const handleExport = () => {
        if (consultatii.length == 0) {
            alertService.error("Nu exista randuri de exportat")
            return;
        }
        reportService.RaportCautarePacientConsultatii({ Code: cnp, Partener: partener }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    return (
        <>
            {consultatii &&
                <>
                <p className="paragraf">Consultatiile pacient:</p>
                <div data-name="lista_consultatii">
                    <table className="tbl" width="100%">
                        <thead>
                            <tr>
                                <th>Nr</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Medic intern</th>
                                <th>Medic trimitator</th>
                                <th>Tip</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Partener</th>
                                <th className="tac">Vezi consultatie</th>
                            </tr>
                        </thead>
                        <tbody>
                          {consultatii.map((consultatie , index) => (
                              <tr key={index}>
                                  <td data-name="nr" className="center">{index + 1}</td>
                                  <td data-name="nume_firma">{consultatie.denumireFirma}</td>
                                  <td data-name="nume_profil">
                                      {consultatie.denumireProfil}
                                      {consultatie.firmaMaster && <span> (</span>}
                                      {consultatie.firmaMaster}
                                      {consultatie.firmaMaster && <span>)</span>}
                                  </td>
                                  <td data-name="nume_medic">{consultatie.numeMedic}</td>
                                  <td data-name="nume_medic_ext"> {consultatie.numeMedicExtern}</td>
                                  <td data-name="tip" className="center">{consultatie.tip}</td>
                                  <td data-name="status" className="center">{consultatie.status}</td>
                                  <td data-name="adaugat_la" className="center">{consultatie.adaugatLa}</td>
                                  <td data-name="partener" className="center">{consultatie.numePartener}</td>
                                    <td>
                                      <a className="icon deschide m0auto"
                                          onClick={() => handleView("consultatie", "consultatie", consultatie.idConsultatie)}
                                          title="Vezi consultatie" data-name="vizualizare">Vizualizare</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div name="export">
                    <button
                        name="btn-export"
                        className="btn"
                        onClick={handleExport}>Export
                    </button>
                </div>
            </>
            }
        </>
    );
};

